import React from 'react';
import LiveJobs from '../../components/AdminNext/LiveJobs';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Live jobs — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <LiveJobs />
      </HeadLessLayout>
    )
  };
}

export default action;
